var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-autocomplete", {
    staticClass: "search-bar",
    attrs: {
      size: "is-small",
      field: "nameLastName",
      rounded: "",
      expanded: _vm.expanded,
      icon: "search",
      data: _vm.entities,
      placeholder: _vm.placeholder,
      loading: _vm.isLoading,
      "append-to-body": true,
    },
    on: { select: (option) => _vm.$emit("select", option) },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c(
              "div",
              { staticClass: "results-list" },
              _vm._l(_vm.parseOption(props.option), function (parsedOption, i) {
                return _c(
                  "div",
                  { key: i, class: parsedOption.divClass },
                  _vm._l(parsedOption.texts, function (text, j) {
                    return _c("span", { key: j, class: text.spanClass }, [
                      _vm._v(" " + _vm._s(text.text) + " "),
                    ])
                  }),
                  0
                )
              }),
              0
            ),
          ]
        },
      },
      {
        key: "empty",
        fn: function () {
          return [_vm._v(_vm._s(_vm.emptyMessage))]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.searchString,
      callback: function ($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }